/**
 * The board renders the institution's Y-site matrix from a BUILD-TIME SNAPSHOT
 * (USB LL0034-V07), generated from the canonical
 * data/semantic-layer/ysite-compat/usb/LL0034-V07/data.json by
 * scripts/gen-matrix-fixture.mjs. The matrix is version-pinned, so the snapshot
 * is this app's source of record — there is NO runtime fetch, and therefore no
 * loading or error state to model (faking one would be dishonest resilience).
 * Regenerate the fixture when the institution publishes a new LL0034 version.
 *
 * If a live matrix source is ever introduced, this accessor is the single place
 * to change; its return type stays `CompatibilityBoardState`.
 */

import { YSITE_MATRIX_FIXTURE } from '../components/compatibility/fixture.matrix'
import type { CompatibilityBoardState } from '@frontend/components/ysite/types'

export function useCompatibilityMatrix(): CompatibilityBoardState {
  return YSITE_MATRIX_FIXTURE
}
